import adrBannerMobileEnglish from '@eti/assets/images/crossSellBanner/adr/en_650.webp';
import adrBannerTabletEnglish from '@eti/assets/images/crossSellBanner/adr/en_1100.webp';
import adrBannerDesktopEnglish from '@eti/assets/images/crossSellBanner/adr/en_1400.webp';
import adrBannerMobileItalian from '@eti/assets/images/crossSellBanner/adr/it_650.webp';
import adrBannerTabletItalian from '@eti/assets/images/crossSellBanner/adr/it_1100.webp';
import adrBannerDesktopItalian from '@eti/assets/images/crossSellBanner/adr/it_1400.webp';

interface CrossSellBanner {
  [index: string]: {
    desktop: string;
    tablet: string;
    mobile: string;
  };
}

export const crossSellBanners: CrossSellBanner = {
  en: {
    desktop: adrBannerDesktopEnglish,
    tablet: adrBannerTabletEnglish,
    mobile: adrBannerMobileEnglish,
  },
  it: {
    desktop: adrBannerDesktopItalian,
    tablet: adrBannerTabletItalian,
    mobile: adrBannerMobileItalian,
  },
};
